import { Formal } from "./ProfileFormal";
// eslint-disable-next-line no-unused-vars
import resume from "../assets/Lucas_2025.pdf";
import { useNavigate } from "react-router-dom";
import backIconColor from "../assets/marbles/Back_icon_blue.mp4";
import backIconClick from "../assets/marbles/Back_icon_click.mp4";
import { useRef, useState } from "react";

const Profile = () => {
  const navigate = useNavigate();
  const [animating, setAnimating] = useState(false);
  const videoRef = useRef(null);
  const [shouldPreloadClick, setShouldPreloadClick] = useState(false);

  const handlePreloadTrigger = () => setShouldPreloadClick(true);

  const handleClick = () => {
    setAnimating(true);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
    setTimeout(() => {
      navigate("/");
      setAnimating(false);
    }, 600);
  };

  return (
    <div className="p-12 font-normal bg-clouds-300 dark:bg-midnight-900 text-clouds-900 dark:text-midnight-50">
      <button
        onClick={handleClick}
        onPointerEnter={handlePreloadTrigger}
        onFocus={handlePreloadTrigger}
        onTouchStart={handlePreloadTrigger}
        className="mb-8 block grayscale hover:grayscale-0 relative"
        style={{ visibility: animating ? "hidden" : "visible" }}
      >
        <video
          src={backIconColor}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          width="64"
          height="64"
          className="w-16"
        />
        {
          <div
            className="absolute top-0"
            style={{ visibility: animating ? "visible" : "hidden" }}
          >
            <video
              src={backIconClick}
              ref={videoRef}
              muted
              playsInline
              preload={shouldPreloadClick ? "auto" : "none"}
              width="64"
              height="64"
              className="w-16"
            />
          </div>
        }
      </button>

      <div className="max-w-3xl text-justify text-xs sm:text-base md:px-8">
        <Formal />
      </div>

      <div className="w-full flex justify-between max-w-3xl mt-12 md:px-8">
        <div className="leading-loose text-xs sm:text-base">
          <h3 className="italic font-bold">CONTACT</h3>
          <h4>
            <a href="mailto:lsf.mov@gmail.com" className="hover:text-accent-500 dark:hover:text-accent-600">
              lsf.mov@gmail.com
            </a>
          </h4>
          +1 786-547-2024
        </div>
        <ul
          className="leading-loose text-right w-[120px] [&>li:hover]:text-accent-500 dark:[&>li:hover]:text-accent-600
                        [&>li:hover]:cursor-pointer text-xs sm:text-base"
        >
          <p className="italic font-bold">LINKS</p>
          <li>
            <a href="http://www.linkedin.com/in/lsfnyc">LinkedIn</a>
          </li>
          <li>
            <a href="https://vimeo.com/lsfnyc">Vimeo</a>
          </li>
          <li>
            <a href="https://www.instagram.com/lsf.mov/">Instagram</a>
          </li>
          <li>
            <a href="https://linktr.ee/somdolucas">Music</a>
          </li>
          {/* <li className="text-[#73fc7a]"><a href={resume}>Resume</a></li> */}
        </ul>
      </div>
    </div>
  );
};

export { Profile };
